export const SeoGuideCarouselTexts = {
  title: 'Как получить займ',
};
